import { useEffect } from 'react';

import { doc, getDoc } from 'firebase/firestore';
import { useParams, useRouter, useSearchParams } from 'next/navigation';

import { ICompany } from 'types/company';

import { getSafeRedirectPath } from 'services/safeRedirect';

import { db } from 'clients/firebase';

import { useAuthGateStore } from 'stores/authGateStore';

import { useUser } from './user';

export const useRedirectToUserCompany = () => {
  const { push } = useRouter();
  const searchParams = useSearchParams();
  const params = useParams<{ companySlug?: string }>();
  const { user } = useUser();
  const setStatus = useAuthGateStore(state => state.setStatus);

  const from = getSafeRedirectPath(searchParams?.get('from'));
  const companySlug = params?.companySlug;

  useEffect(() => {
    let cancelled = false;

    (async () => {
      if (!user?.profile?.companyId) {
        setStatus('idle');
        return;
      }

      try {
        if (from) {
          if (cancelled) return;
          setStatus('redirecting');
          return push(from);
        }

        const companyId =
          user.profile.companyId !== '*'
            ? user?.profile.companyId
            : process.env.NEXT_PUBLIC_DEFAULT_COMPANY_ID;

        const companyDoc = await getDoc(doc(db, `Companies/${companyId}`));
        if (cancelled) return;
        setStatus('redirecting');
        push(`/${(companyDoc.data() as ICompany).slug}`);
      } catch (error) {
        if (cancelled) return;
        setStatus('error');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [push, companySlug, from, user, setStatus]);
};
